import { render } from "./AfternoonLoseOverlay.vue?vue&type=template&id=5966ad96&scoped=true"
import script from "./AfternoonLoseOverlay.vue?vue&type=script&lang=js"
export * from "./AfternoonLoseOverlay.vue?vue&type=script&lang=js"

import "./AfternoonLoseOverlay.vue?vue&type=style&index=0&id=5966ad96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5966ad96"]])

export default __exports__